import UpgradeBannerContainer from "~/common/subscriptions/UpgradeBannerContainer"

export default UpgradeBannerContainer
